export default function InformationCell ({comment}) {
    return (
        <>
            {comment && <div className="commentCell">
                &#9432;
                {/* <div className="commentCell-symbol">&#9888;</div> */}
                <span className="commentCell-text">{comment}</span>
                </div>}
        </>
    )
}